import React from "react";
import HeroSection from "./HeroSection/HeroSection";
import ScholarshipList from "./ScholarshipList/ScholarshipList";
import ReceviedScholarships from "../ReceviedScholarships/ReceviedScholarships";
import FAQs from "../FAQs/FAQs";
import Banner1 from "../Banner1/Banner1";

const CountrySpecificScholarship = (props: any) => {
  const scholarshipCountryData = props.pageData?.[0];
  const topScholarships = scholarshipCountryData?.topScholarships ?? {};
  const faqData = scholarshipCountryData?.faq ?? {};
  const bannerData = scholarshipCountryData?.banner ?? {};
  const scholarshipsPrograms = scholarshipCountryData?.scholarshipsPrograms ?? {};
  const searchScholarship = scholarshipCountryData?.searchScholarship ?? {};

  const hasData = (obj: object) => Object.keys(obj).length > 0;

  return (
    <>
      <div id="countrySholarshipsPage">
        <HeroSection scholarshipCountryData={scholarshipCountryData} />
        <ScholarshipList scholarshipCountryData={scholarshipCountryData} scholarshipsPrograms={scholarshipsPrograms} searchScholarship={searchScholarship} />
        {hasData(topScholarships) && <ReceviedScholarships topScholarships={topScholarships} />}
        {hasData(faqData) && <FAQs faqData={faqData} />}
        {hasData(bannerData) && <Banner1 bannerData={bannerData} />}
      </div>
    </>
  );
};

export default CountrySpecificScholarship;
